module.exports = __webpack_public_path__ + "static/img/watch.1fa8d53d.png";